import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {Router} from '@angular/router';
import {takeUntil} from 'rxjs';
import {NavigationEventService} from 'src/app/add-ons/navigation-event.service';
import {OnDestroySubject} from 'src/app/data/model/on-destroy-subject';

@Component({
  selector: 'app-add-on-header',
  templateUrl: './add-on-header.component.html',
  styleUrls: ['./add-on-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'app-addon-header'},
  standalone: false,
})
export class AddOnHeaderComponent extends OnDestroySubject {
  @Input() previousRoute: string;
  @Input() cartSubtotal: number;
  @Input() enableCart: boolean;
  @Input() showUpfrontText: boolean;
  @Input() cartItemCount = 0;
  @Output() cartClick = new EventEmitter<void>();

  constructor(
    private navigationEventService: NavigationEventService,
    private router: Router,
  ) {
    super();
    this.navigationEventService.backClick
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.back();
      });
  }

  get showBackButton(): boolean {
    return !!this.previousRoute;
  }

  back(): void {
    if (this.previousRoute) {
      this.router.navigate([
        {outlets: {commerceElement: `${this.previousRoute}`}},
      ]);
    }
  }
}
